import React from 'react';
import { ShieldCheck } from 'lucide-react';
export function GuaranteeSection() {
  return <section className="py-20 bg-stone-50 border-t border-stone-200" data-id="element-140">
      <div className="container mx-auto px-4 text-center max-w-3xl" data-id="element-141">
        <div className="inline-flex items-center justify-center p-4 bg-white rounded-full shadow-sm mb-8" data-id="element-142">
          <ShieldCheck className="w-8 h-8 text-stone-800" data-id="element-143" />
        </div>
        <h2 className="text-3xl font-serif font-bold mb-6" data-id="element-144">
          Compra con total seguridad.
        </h2>
        <p className="text-lg text-gray-600 leading-relaxed mb-8" data-id="element-145">
          Recuerda: lo que ves es lo que recibes. Un producto voluminoso,
          impecable y listo para transformar tu clóset.
        </p>
        <div className="flex items-center justify-center gap-2 text-sm font-medium text-stone-500 uppercase tracking-widest" data-id="element-146">
          <span data-id="element-147">Envío seguro a todo México</span>
          <span className="w-1.5 h-1.5 rounded-full bg-stone-400" data-id="element-148"></span>
          <span data-id="element-149">Calidad Garantizada</span>
        </div>
      </div>
    </section>;
}